import BaseUrlManager from './base-url-manager';
import {BASE_PATH} from 'config';
import UserAgent from 'helpers/device';

class URLManager extends BaseUrlManager {
    constructor(list = {}) {
        super(list);
    }
    to(request, params = {}) {
        let url;
        try {
            url = super.to(request);
        } catch (e) {
            url = BASE_PATH + this.deviceTypePrefix() + request;
        }
        this.deviceTypePrefix();

        if (!isEmpty(params)) {
            let query = '';
            for (let key in params) {
                query += '/' + params[key];
            }
            url += query;
        }

        return url;
    }
    deviceTypePrefix() {
        return UserAgent.isMobile() ? '/mobile' : '/desktop';
    }
    toHome() {
        return BASE_PATH + this.deviceTypePrefix();
    }
}

const URL = new URLManager();

export default URL;
